export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const SAVE_NOTIFICATION = "SAVE_NOTIFICATION";
export const UPDATE_COUNT = "UPDATE_COUNT";